/** @file The import dialog: follows its session's store; closed renders nothing. */
import type { CatalogKey, Translate } from '@pose2d/i18n/types';
import { useStore } from 'zustand';
import { Dialog } from '../ui-kit/Dialog';
import { ImportDone } from './ImportDone';
import { ImportFooter } from './ImportFooter';
import { ImportStepBody } from './ImportStepBody';
import type { ImportSession, ImportStep } from './importTypes';
import './import.css';

/** PNG wording once the source is PNG files (or while they are read), PSD wording otherwise. */
function titleOf(step: Exclude<ImportStep, { kind: 'closed' }>): CatalogKey {
  if (step.kind === 'reading') return step.sourceKind === 'png' ? 'psdImport.titlePng' : 'psdImport.titlePsd';
  const draft = 'draft' in step ? step.draft : null;
  return draft?.source.kind === 'png' ? 'psdImport.titlePng' : 'psdImport.titlePsd';
}

/** Escape and the backdrop call session.close, which is ignored while an upload runs. */
export function ImportDialog({ t, session }: { t: Translate; session: ImportSession }) {
  const step = useStore(session.store, (s) => s);
  if (step.kind === 'closed') return null;
  return (
    <Dialog open title={t(titleOf(step))} closeLabel={t('psdImport.close')} onClose={session.close} footer={<ImportFooter t={t} step={step} session={session} />}>
      <ImportStepBody t={t} step={step} session={session} />
      {step.kind === 'done' ? <ImportDone t={t} outcome={step.outcome} /> : null}
    </Dialog>
  );
}
